export default function splitURL(url?: string) {
  const fullURL = url || window.location.href;

  const urlRegExp = /^http(s?):\/\/([^\/]+)\/(latest|V[0-9]\.[0-9]{1,2}(\.[0-9]{0,3})?)?\/?(.*)/;

  const matches = urlRegExp.exec(fullURL);

  const isSecure = matches[1] !== '';
  const domain = matches[2];
  const version = (matches[3] && matches[3].replace('/', '')) || '';
  const hasSubfolder = matches[3] !== '';
  const path = matches[5];
  const rootURL = `http${matches[1]}://${domain}/${version}`;

  return {
    fullURL,
    rootURL,
    isSecure,
    domain,
    version,
    hasSubfolder,
    path,
  };
}
